import { useEffect, useState } from "react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

// The actual beforeinstallprompt capture lives in public/index.html — it
// fires earlier than this bundle can mount, so index.html stashes it on
// window.__clarityDeferredInstallPrompt and dispatches "clarity-install-available".
// This hook just reads that global and reacts to the custom event.
export function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(() => window.__clarityDeferredInstallPrompt || null);
  const [installed, setInstalled] = useState(isStandalone);

  useEffect(() => {
    const onAvailable = () => setDeferredPrompt(window.__clarityDeferredInstallPrompt || null);
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener("clarity-install-available", onAvailable);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("clarity-install-available", onAvailable);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    window.__clarityDeferredInstallPrompt = null;
    setDeferredPrompt(null);
  };

  return { canInstall: !installed && !!deferredPrompt, promptInstall };
}
